export const getTotal = (array = [], field = "") => {
  return array.reduce((act, next) => {
    return act + next[field];
  }, 0);
};

export const getPercentage = (array = [], field = "") => {
  return (
    array.reduce((act, next) => {
      return act + next[field];
    }, 0) / array.length
  );
};